import NearMeIcon from '@mui/icons-material/NearMe';
import ChairIcon from '@mui/icons-material/Chair';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import MultipleStopIcon from '@mui/icons-material/MultipleStop';

export const QUESTIONS = [
  { title: 'assistant.questions.question1', icon: NearMeIcon },
  { title: 'assistant.questions.question2', icon: ChairIcon },
  { title: 'assistant.questions.question3', icon: SentimentSatisfiedAltIcon },
  { title: 'assistant.questions.question4', icon: MultipleStopIcon },
];
